import React from 'react';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import {
  withStyles,
} from '@material-ui/core';
import { observer } from 'mobx-react';
import moment from 'moment';

import { DataTable } from 'components';
import NormPackages from 'views/NormPackages';


import styles from './styles';

class NormPackageListContainer extends React.Component {

  componentDidMount() {
    this.props.store.getAll();
  }

  componentWillUnmount() {
    this.props.store.reset();
  }

  prepareTableColumns() {
    const { t } = this.props;
    const columns = [
      'ID',
      'LINK',
      t('Kodas'),
      t('Pavadinimas'),
      t('Sukurtas'),
      t('Rinkinių'),
    ];

    return columns;
  }

  prepareTableData(records) {
    const data = _.map(records, record => {
      let row = [];

      row.push(record._id);
      row.push(`/norm-packages/${record._id}`);
      row.push(record.code);
      row.push(record.title);
      row.push(record.createdAt ? moment(record.createdAt).utc().format('YYYY-MM-DD') : null);
      row.push(record.collections ? record.collections.length : 0);
      
      return row;
    });

    return data;
  }

  render() {
    const { classes, store, t } = this.props;

    const columns = this.prepareTableColumns();
    const data = this.prepareTableData(store.records);

    return (
      <NormPackages
        title={t('Normatyvų paketai')}
        breadcrumbs={[
          { title: t('Administravimas') },
          { title: t('Normatyvų paketai') }
        ]}
      >
        <div className={classes.wrap}>
          <DataTable 
            key={data.length}
            columns={columns}
            data={data}
            tableHeight={window.innerHeight > 900 ? '65vh' : '45vh'}
            createUrl="/norm-packages/create"
            // onDelete={(idx) => dispatch(deleteOne(companies[idx]._id))}
            // onDeleteBatch={(indexes) => dispatch(deleteBatch(_.map(indexes, (idx) => companies[idx]._id)))}
          />
        </div>
      </NormPackages>
    )
  }
}

export default compose(withStyles(styles), withTranslation())(observer(NormPackageListContainer));